import { render, staticRenderFns } from "./BalancerOutputsPerformance.vue?vue&type=template&id=8879c62a&scoped=true"
import script from "./BalancerOutputsPerformance.vue?vue&type=script&lang=js"
export * from "./BalancerOutputsPerformance.vue?vue&type=script&lang=js"
import style0 from "./BalancerOutputsPerformance.vue?vue&type=style&index=0&id=8879c62a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8879c62a",
  null
  
)

export default component.exports